import React from "react";
import { useNavigate } from "react-router-dom";
import { createGalleryImage } from "adminApi/GalleryApi/Gallery";
import { validateForm } from "utils/validation";
import { GalleryRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddGalleryForm from "./Componates/AddGalleryForm";
import fields from "../json/GalleryFields.json"; 
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddGallery = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Default initial form values from JSON
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }),{});

  // Form input change management
  const { values, errors, handleChange, handleFileChange } = useFormChange(
    initialValues,
    GalleryRules
  );

  // Form submission management
  const { loading, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => {
        formData.append(key, val ?? "");
      });
      return await createGalleryImage({data:formData});
    },
    (vals) => validateForm(vals, GalleryRules),
    () => navigate(-1),
    "Gallery image Created successfully"
  );

  return (
    <>
      {loading && <Spinner isSpinner={true} />}
      <AddGalleryForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleFileChange={handleFileChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loading}
        imagePreview={values.imagePreview || (values.image && values.image)}
      />
    </>
  );
};

export default AddGallery;
